import { render, staticRenderFns } from "./Merit.vue?vue&type=template&id=bb4894e4&scoped=true&"
import script from "./Merit.vue?vue&type=script&lang=js&"
export * from "./Merit.vue?vue&type=script&lang=js&"
import style0 from "./Merit.vue?vue&type=style&index=0&id=bb4894e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4894e4",
  null
  
)

export default component.exports